import * as React from 'react';

import { CountryFormatter } from '@longline/aqua-ui/formatters/CountryFormatter';
import { Message } from '@longline/aqua-ui/containers/Message';
import { ListView } from '@longline/aqua-ui/controls/ListView';

import { ISystem, ISystemProxy } from '../../api/models/ISystem';
import { ISystemFilter } from "../../filters/SystemFilter";

interface IProps {
  systems: ISystemProxy[];
  loading?: boolean;
  filter: ISystemFilter;
  onClearFilter: () => void;
  onCheck?: (data: ISystemProxy[], item: any | true | false) => void;
}

const SystemListView = (props: IProps) => {

  const hasFilter = () => ((props.filter.q != null && props.filter.q != "") || props.filter.country != null || props.filter.division != null);

  const renderNoData = () => {
    if (hasFilter()) {
      return (
        <Message.NoFilteredData margin onClear={props.onClearFilter}>
          No systems found. Your query may be too restrictive.
        </Message.NoFilteredData>
      )
    } else {
      return (
        <Message.NoData margin>
          This user has no systems.
        </Message.NoData>
      )
    }
  }     
  
  // Filter systems. This is memoized for speed.
  const filteredSystems = React.useMemo(() => {
    return (props.systems || [])
    .filter(c => c.name.toLocaleLowerCase().includes((props.filter.q || "").toLocaleLowerCase()))
    .filter(c => !props.filter.country || (c.country == props.filter.country && (!props.filter.division || c.division == props.filter.division)));
  }, [props.systems, props.filter]);    

  return (
    <ListView 
      dark 
      ghost={props.loading}
      onCheck={props.onCheck}
      data={filteredSystems} 
      shadow
      total
      hover
      singular={`system (${(props.systems || []).filter(s => (s as any).checked).length} selected)`}
      plural={`systems (${(props.systems || []).filter(s => (s as any).checked).length} selected)`}
      rowHeight={56}
      noData={renderNoData()}
    >
      <ListView.Column active width={1} name="Name" defaultSort sort="name">{(item: ISystem) => item.name}</ListView.Column>
      <ListView.Column active width="110px" name="Country" align="right">
        {(item: ISystem) => <CountryFormatter type="flag" value={item.country ?? ""}/>}
      </ListView.Column>                
    </ListView>  
  )
}

export { SystemListView }
